import { RefObject, useEffect, useRef } from 'react'
import { handleTabReturn, TAB_RETURN_RECHECK_MS } from 'lib/tabReturn'

export const useTabReturnRecheck = ({
  enabled,
  recheck,
  lastCheckAtRef,
  minIntervalMs = TAB_RETURN_RECHECK_MS
}: {
  enabled: boolean
  recheck: () => void
  lastCheckAtRef: RefObject<number | null>
  minIntervalMs?: number
}): void => {
  const latest = useRef({ enabled, recheck, minIntervalMs })
  useEffect(() => {
    latest.current = { enabled, recheck, minIntervalMs }
  })

  useEffect(() => {
    const onReturn = (): void => {
      handleTabReturn({
        ...latest.current,
        lastCheckAtRef,
        visibilityState: globalThis.document.visibilityState,
        nowMs: Date.now()
      })
    }
    globalThis.document.addEventListener('visibilitychange', onReturn)
    globalThis.addEventListener('focus', onReturn)
    return () => {
      globalThis.document.removeEventListener('visibilitychange', onReturn)
      globalThis.removeEventListener('focus', onReturn)
    }
  }, [lastCheckAtRef])
}
